import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgManageAmericaLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 16,
	viewBox: "0 0 24 16",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.36621 15.71H14.0473V13.4476H9.36621V15.71Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.36475 9.3179V11.1855H14.0459V9.3179L11.7052 8.01175L9.36475 9.3179Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0644 11.1852H18.7239V6.53142L14.0428 3.91888L16.3832 2.61273L21.0644 5.21595V11.1852ZM4.68085 6.53142L4.68111 11.1852H2.34069V5.21595L7.02102 2.60819L9.36171 3.91888L4.68085 6.53142ZM16.3832 0.000185013L11.7021 2.61273L7.02102 0.000185013L0 3.90981V13.4476H4.68111V15.71H7.02102V7.83757L11.7021 5.22527L16.3832 7.83757V15.71H18.7239V13.4476H23.4048V3.90981L16.3832 0.000185013Z",
			fill: "white"
		})
	]
});
export default SvgManageAmericaLogo;
